document.addEventListener('DOMContentLoaded', function () {

  // search overlay
  const searchBtn = document.getElementById('searchBtn');
  const searchOverlay = document.getElementById('searchOverlay');
  const closeSearchOverlay = document.getElementById('closeSearchOverlay');

  searchBtn.addEventListener('click', function () {
    searchOverlay.classList.remove('opacity-0', 'translate-y-full');
    searchOverlay.classList.add('opacity-100', 'translate-y-0');
  });

  closeSearchOverlay.addEventListener('click', function () {
    searchOverlay.classList.remove('opacity-100', 'translate-y-0');
    searchOverlay.classList.add('translate-y-full');
    setTimeout(function () {
      searchOverlay.classList.add('opacity-0');
    }, 500);
  });

  if (document.getElementById('splide')) {
    new Splide('#splide', {
      type: 'loop',
      perPage: 1,
      pagination: false,
      gap: '1em',
      focus: 'center',
      autoplay: true,
      interval: 3000,
      wheel: true,
      flickMaxPages: 1,
      updateOnMove: true,
      direction: 'rtl',
      arrows: true,
      // padding: '10%',
    }).mount();
  }

  // *.*.*.*.*.*.*.*.*.*.* START OF show hide author content *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  if (document.querySelector('.profile_content_display')) {
    if (document.querySelector(".profile_content_display").scrollHeight > 250) {
      document.querySelector(".profile_content_button").addEventListener('click', function () {
        document.querySelector(".profile_content_display").classList.toggle('profile_content_display_show');
        document.querySelector(".profile_content_display").style.maxHeight = document.querySelector(".profile_content_display").scrollHeight + "px";
        document.querySelector(".profile_content_button").style.display = "none";
      })
    } else {
      if (document.querySelector('.profile_content_display')) {
        document.querySelector(".profile_content_button").style.display = "none";
      }
    }
  }
  // *.*.*.*.*.*.*.*.*.*.* END OF show hide author content *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*

  // *.*.*.*.*.*.*.*.*.*.* START OF tiny url company page *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  if (document.querySelector(".short_link")) {
    var shortLink = document.querySelector(".short_link");
    if (shortLink) {
      shortLink.addEventListener("click", function (event) {
        event.preventDefault();
        var temp = document.getElementById("short_link_copy");
        temp.select();
        document.execCommand("copy");
        document.querySelector(".copied").style.display = "block";
        setTimeout(function () {
          document.querySelector(".copied").style.display = "none";
        }, 1500);
      });
    }
  }
  // *.*.*.*.*.*.*.*.*.*.* END OF tiny url *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*

  // *.*.*.*.*.*.*.*.*.*.* Responsive table *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  if (document.querySelector(".editor_styles")) {
    var tables = document.querySelectorAll(".editor_styles table");
    tables.forEach(function (table) {
      var parentTable = document.createElement('div');
      parentTable.classList.add("table_res");
      document.querySelector(".editor_styles").replaceChild(parentTable, table);
      parentTable.appendChild(table);
    });
  }


  // *.*.*.*.*.*.*.*.*.*.* START OF TABs *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  function setupTabs(tabButtons, contentBoxes, container) {
    const tabs = Array.from(container.querySelectorAll(tabButtons));
    const contents = Array.from(container.querySelectorAll(contentBoxes));

    tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => {
        tabs.forEach((tab, i) => {
          if (i === index) {
            tab.classList.add("active");
            contents[i].classList.add("visible");
          } else {
            tab.classList.remove("active");
            contents[i].classList.remove("visible");
          }
        });
      });
    });
  }

  // Setting up all the main tab containers
  document.querySelectorAll(".primary_multi_tab").forEach((container) => {
    setupTabs(".tabs_title li", ".tab_content", container);
    // container.querySelectorAll(".tab_content").forEach((tabContent) => {
    // setupTabs(".subtabs > div", ".subtab_content", tabContent);
    // });
  });
  // *.*.*.*.*.*.*.*.*.*.* END OF TABs *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*

  // *.*.*.*.*.*.*.*.*.*.* START OF main menu *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*

  // Main menu toggle
  const mainMenu = document.querySelector(".top_nav");
  const menuToggleButton = document.querySelector(".menu_btn_cnt");

  if (mainMenu && menuToggleButton) {
    menuToggleButton.addEventListener('click', () => {
      setTimeout(() => {
        mainMenu.classList.toggle('slide_down');
        menuToggleButton.classList.toggle('close_open');
      }, 10);
    });
  }

  // ----- SUB_MENU -----
  document.querySelectorAll('.sub_menu_btn').forEach(subMenuButton => {
    subMenuButton.addEventListener('click', () => {
      setTimeout(() => {
        const subMenu = subMenuButton.nextElementSibling;
        if (subMenu) {
          subMenu.classList.toggle('slide_down');
        }
      }, 10);
    });
  });
  // ----- END OF SUB_MENU -----

  // *.*.*.*.*.*.*.*.*.*.* END OF main menu *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*

  // *.*.*.*.*.*.*.*.*.*.* archive toggle *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  if (document.querySelector('.archive-checkbox .flip')) {
    document.querySelectorAll('.archive-checkbox .flip').forEach(flip => {
      flip.addEventListener('click', function () {
        const panel = this.nextElementSibling;
        panel.classList.toggle('max-h-0');
        panel.classList.toggle('max-h-auto');
        panel.classList.toggle('opacity-0');
        panel.classList.toggle('opacity-100');
        panel.classList.toggle('pointer-events-none');
        panel.classList.toggle('pointer-events-auto');
      });
    });
  }
  // *.*.*.*.*.*.*.*.*.*.* END OF archive toggle *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*


  // hamburger menu
  const hamburgerBtn = document.getElementById('hamburgerBtn');
  const mobileMenu = document.getElementById('mobileMenu');
  const closeMenu = document.getElementById('closeMenu');

  if (hamburgerBtn && mobileMenu && closeMenu) {
    hamburgerBtn.addEventListener('click', function () {
      mobileMenu.classList.remove('translate-x-full');
      mobileMenu.classList.add('translate-x-0');
    });

    closeMenu.addEventListener('click', function () {
      mobileMenu.classList.remove('translate-x-0');
      mobileMenu.classList.add('translate-x-full');
    });
  }

  // mobile menu dropdown
  const dropdownToggle = document.querySelectorAll('.dropdown-toggle');
  for (let i = 0; i < dropdownToggle.length; i++) {
    const toggle = dropdownToggle[i];
    const svgIcon = toggle.nextElementSibling;

    svgIcon.addEventListener('click', function (event) {
      event.preventDefault();
      toggle.checked = !toggle.checked;
      document
        .querySelector(`.dropdown-${toggle.value}`)
        .classList.toggle('hidden', !toggle.checked);
      svgIcon
        .querySelector('svg')
        .classList.toggle('rotate-180', toggle.checked);
    });
  }



  // ---------------------------------------------------------------first tab
  if (document.querySelector('.home #tabs')) {
    let tabsContainer = document.querySelector('#tabs');
    let tabTogglers = tabsContainer.querySelectorAll('#tabs li a');

    tabTogglers.forEach(function (toggler) {
      toggler.addEventListener('click', function (e) {
        e.preventDefault();

        let tabName = this.getAttribute('href');

        let tabContents = document.querySelector('#tab-contents');

        for (let i = 0; i < tabContents.children.length; i++) {
          tabTogglers[i].parentElement.classList.remove(
            // 'border-t',
            // 'border-r',
            // 'border-l',
            // '-mb-px',
            'bg-black',
            'text-white'
          );
          console.log(tabContents.children[i], 'rrrrrrrrrrrr');

          tabContents.children[i].classList.remove('hidden');
          if ('#' + tabContents.children[i].id === tabName) {
            continue;
          }
          tabContents.children[i].classList.add('hidden');
        }
        e.target.parentElement.classList.add(
          // 'border-t',
          // 'border-r',
          // 'border-l',
          // '-mb-px',
          'bg-black',
          'text-white'
        );
      });
    });
  }
  // ---------------------------------------------------------------second tab
  // let tabContainer = document.querySelector('#second_tabs');

  // let tabsTogglers = tabContainer.querySelectorAll('#second_tabs li a');

  // tabsTogglers.forEach(function (toggler) {
  // 	toggler.addEventListener('click', function (e) {
  // 		e.preventDefault();

  // 		let tabName = this.getAttribute('href');

  // 		let tabsContents = document.querySelector('#second-tab-contents');

  // 		for (let i = 0; i < tabsContents.children.length; i++) {
  // 			tabsTogglers[i].parentElement.classList.remove(
  // 				// 'border-t',
  // 				// 'border-r',
  // 				// 'border-l',
  // 				// '-mb-px',
  // 				'bg-white',
  // 				'text-black'
  // 			);
  // 			console.log(tabsContents.children[i], 'rrrrrrrrrrrr');

  // 			tabsContents.children[i].classList.remove('hidden');
  // 			if ('#' + tabsContents.children[i].id === tabName) {
  // 				continue;
  // 			}
  // 			tabsContents.children[i].classList.add('hidden');
  // 		}
  // 		e.target.parentElement.classList.add(
  // 			// 'border-t',
  // 			// 'border-r',
  // 			// 'border-l',
  // 			// '-mb-px',
  // 			// 'bg-black',
  // 			'bg-white',
  // 			'text-black'
  // 		);
  // 	});
  // });

  // ---------------------------------------------------------------THIRD tab
  // let tabContainers = document.querySelector('#third_tabs');

  // let tabsTogglersss = tabContainers.querySelectorAll('#third_tabs li a');

  // tabsTogglersss.forEach(function (toggler) {
  // 	toggler.addEventListener('click', function (e) {
  // 		e.preventDefault();

  // 		let tabsName = this.getAttribute('href');

  // 		let tabsContentsss = document.querySelector('#third-tab-contents');

  // 		for (let i = 0; i < tabsContentsss.children.length; i++) {
  // 			tabsTogglersss[i].parentElement.classList.remove(
  // 				// 'border-t',
  // 				// 'border-r',
  // 				// 'border-l',
  // 				// '-mb-px',
  // 				'bg-white',
  // 				'text-black'
  // 			);
  // 			console.log(tabsContentsss.children[i], 'rrrrrrrrrrrr');

  // 			tabsContentsss.children[i].classList.remove('hidden');
  // 			if ('#' + tabsContentsss.children[i].id === tabsName) {
  // 				continue;
  // 			}
  // 			tabsContentsss.children[i].classList.add('hidden');
  // 		}
  // 		e.target.parentElement.classList.add(
  // 			// 'border-t',
  // 			// 'border-r',
  // 			// 'border-l',
  // 			// '-mb-px',
  // 			// 'bg-black',
  // 			'bg-white',
  // 			'text-black'
  // 		);
  // 	});
  // });



})
